import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/Service/Common.service';
import { MemberRoleLinkService } from 'src/app/Service/member-role-link/member-role-link.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { GridComponent } from '@progress/kendo-angular-grid';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { IDelegateAccessViewModel } from 'src/app/ViewModel/DelegateAccessModel';
import { DelegateAccessService } from 'src/app/Service/delegate-access/delegate-access.service';
import * as moment from 'moment';

const createFormGroup = (dataItem: { projectId: any; memberId: any; memberName?: string; delegatedMemberId: any; delegatedMemberName: any; fromDate: any; toDate: any; isActive: any; }) => new FormGroup({
  'projectId': new FormControl(dataItem.projectId),
  'memberId': new FormControl(dataItem.memberId),
  'delegatedMemberName': new FormControl(dataItem.delegatedMemberName),
  'delegatedMemberId': new FormControl(dataItem.delegatedMemberId),
  'fromDate': new FormControl(dataItem.fromDate, Validators.required),
  'toDate': new FormControl(dataItem.toDate, Validators.required),
  'isActive': new FormControl(dataItem.isActive),

});
@Component({
  selector: 'app-delegate-access',
  templateUrl: './delegate-access.component.html',
  styleUrls: ['./delegate-access.component.css']
})
export class DelegateAccessComponent implements OnInit {

  @ViewChild(GridComponent)
  private grid!: GridComponent;
  public memberList: ReadonlyArray<ProjectMemberModel> = [];
  public fromMemberList: ReadonlyArray<ProjectMemberModel> = [];
  public toMemberList: ReadonlyArray<ProjectMemberModel> = [];


  public delegateaccesslist: any | any[] = [];

  public formGroup: FormGroup | undefined;
  private editedRowIndex!: any | number;
  public start = new Date();
  public end = new Date();
  public selectedFromMemberId: string | number | null = 0;
  public selectedMemberId: string | number | null = 0;
  public selectedMember: string = '';
  isNew = false;
  isNewRow = false;
  isAdmin = false;
  fromDates: any | Map<string, Date> = new Map<string, Date>();
  toDates: any | Map<string, Date> = new Map<string, Date>();
  memberId: number = 0;
  projectId!: number;
  groupId: number = 0;


  /** Selected row id */
  editedRowId: any = null;
  editedRowMemberId: any = null;
  enableFilter = false;
  enableFullscreen = false;
  public pageSize = [20, 50, 100, 200, {
    text: 'All',
    value: 'all'
  }];

  constructor(
    private memberRoleLinkService: MemberRoleLinkService,
    private commonService: CommonService,
    private delegateAccessService: DelegateAccessService,
    private notificationService: NotificationService) { }

  ngOnInit() {

    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe(async (result: any[]) => {
      result = result.filter(x => x.role_Desc == 'ISD');
      if (result.length > 0) {
        this.isAdmin = true;
      }
    });
    this.callApis();
  }

  callApis() {
    var date = new Date();
    this.start = new Date(date.getFullYear(), date.getMonth(), 1);
    this.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.getMemberList();
    this.getDelegateAccessList();
  }

  public async getMemberList() {
    this.memberList = await this.memberRoleLinkService.getMembersList(this.projectId, this.groupId).toPromise();
    if (this.isAdmin) {
      this.fromMemberList = this.memberList;
      this.toMemberList = this.memberList;
    }
    else {
      this.fromMemberList = this.memberList.filter(data => data.memberId == this.memberId);
      this.toMemberList = this.memberList.filter(data => data.memberId != this.memberId);
    }
  }

  getDelegateAccessList() {
    this.delegateAccessService.getDelegateAccessList().subscribe((data: any[]) => {
      this.delegateaccesslist = data;
      this.delegateaccesslist.map((x: any, index: any) => {
        x.index = index;
        this.fromDates[index] = new Date(x.fromDate);
        this.toDates[index] = new Date(x.toDate);
      });
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  changeActiveStatus(event: any) {
    this.formGroup?.get('isActive')?.setValue(event);
  }

  changeMember(event: { value: string | number; text: string; }) {

    if (event.value != '-2') {
      this.selectedMemberId = event.value;
      this.selectedMember = event.text;
    } else {
      this.selectedMemberId = null
      this.selectedMember = '';

    }
  }

  changeFromMember(event: { value: string | number; }) {
    if (event.value != '-2') {
      this.selectedFromMemberId = event.value;
    } else {
      this.selectedFromMemberId = null
    }
  }


  editRowData(data: any) {
    //closing previous row, if anything opened
    if (this.editedRowIndex >= 0) {
      data.sender.closeRow(this.editedRowIndex);
    }
    this.editedRowIndex = data.rowIndex;
    this.formGroup = createFormGroup(data.dataItem);
    this.selectedMemberId = data.dataItem.delegatedMemberId;
    this.selectedMember = data.dataItem.delegatedMemberName;
    this.selectedFromMemberId = data.dataItem.memberId;
    this.start = data.dataItem.fromDate;
    this.end = data.dataItem.toDate;
    this.isNewRow = false;
    this.formGroup.get('isActive')?.setValue(data.dataItem.isActive);
    data.sender.editRow(data.rowIndex);
  }

  UpdateRowData(data: any) {
    this.saveDelegateAccess();
    this.isNewRow = false;
    data.sender.closeRow(data.rowIndex);
  }

  cancelRowData(data: any) {
    this.isNewRow = false;
    data.sender.closeRow(data.rowIndex);
  }

  addHandler() {
    this.isNewRow = true;
    this.closeEditor();
    this.formGroup = createFormGroup({
      projectId: this.projectId,
      memberId: 0,
      memberName: '',
      delegatedMemberId: 0,
      delegatedMemberName: '',
      fromDate: '',
      toDate: '',
      isActive: true,
    });
    this.isNew = true;
    this.grid.addRow(this.formGroup);
  }


  public cellClickHandler(data: any): void {
    if (data.isEdited) {
      return;
    }
    this.saveDelegateAccess();
    this.formGroup = createFormGroup(data.dataItem);
    this.editedRowIndex = data.rowIndex;
    this.grid.editRow(data.rowIndex, this.formGroup);
  }

  public cancelHandler(): void {
    this.closeEditor();
  }

  private closeEditor(): void {
    this.grid.closeRow(this.editedRowIndex);
    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  /**
*
* Add/Update Delegate Access API Call
*/
  private saveDelegateAccess(): void {

    if (new Date(this.end) < new Date(this.start)) {
      this.notificationService.showToast("Invalid Date Range", "Warning");
      return;
    }

    if (this.selectedFromMemberId != this.selectedMemberId) {
      if (this.formGroup) {
        let inputmodel: any | IDelegateAccessViewModel = {
          'projectId': this.projectId,
          'delegatedMemberName': this.selectedMember,
          'memberId': this.selectedFromMemberId,
          'delegatedMemberId': this.selectedMemberId,
          'fromDate': (moment(this.start)).format('DD/MM/YYYY'),
          'toDate': (moment(this.end)).format('DD/MM/YYYY'),
          'isActive': this.formGroup.get('isActive')?.value,
          'userId': this.memberId,
        };
        this.delegateAccessService.addDelegateAccess(inputmodel).subscribe((res: StandardOutputModel) => {
          this.notificationService.handleResponse(res);
          this.callApis();
        });
        this.closeEditor();
      }
    }
    else {
      this.notificationService.showToast("Can't be able to delegate the same person", "Warning");
      return;
    }

  }
  /**
  *
  * @param selectedText
  */
  getFromDateValue(selectedText: any) {
    selectedText.value == null;
    this.start = selectedText.value;
  }

  getToDateValue(selectedText: any) {
    selectedText.value == null;
    this.end = selectedText.value;
  }
  getTimeValue(selectedText: any) {
  }

}

